import { render, staticRenderFns } from "./VisitasView.vue?vue&type=template&id=1c258a53"
import script from "./VisitasView.vue?vue&type=script&lang=js"
export * from "./VisitasView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports